import Logo from "../styles/kronoLogo.png";
import Location from "../styles/location.svg?react";
import Instagram from "../styles/instagram.svg?react";
import Whatsapp from "../styles/whatsapp.svg?react";
import "../styles/Main.css";

export const Main = () => {
  return (
    <>
      <br />
      <center>
        <img src={Logo} alt="Logo" style={{ height: "10rem" }} />
        <div className="main-title">Alta Calidad en Gemas</div>
        
        {/* Mensaje de redirección a la nueva página oficial */}
        <div style={{ 
          margin: "20px 0", 
          padding: "15px", 
          backgroundColor: "#f8f9fa", 
          borderRadius: "10px",
          maxWidth: "400px"
        }}>
          <p style={{ 
            fontSize: "14px", 
            color: "#666", 
            margin: "0 0 15px 0",
            lineHeight: "1.4"
          }}>
            ¡La página oficial de Krono ha cambiado de ubicación!
          </p>
          <button
            onClick={() => window.open('http://www.krono.com.mx', '_blank')}
            style={{
              backgroundColor: "#6ca886",
              color: "white",
              border: "none",
              padding: "12px 24px",
              borderRadius: "25px",
              fontSize: "14px",
              fontWeight: "bold",
              cursor: "pointer",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 15px rgba(108, 168, 134, 0.3)"
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#5a9274";
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 20px rgba(108, 168, 134, 0.4)";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "#6ca886";
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 4px 15px rgba(108, 168, 134, 0.3)";
            }}
          >
            🌟 Da click aquí para ir a krono.com.mx
          </button>
        </div>
        
        <div className="main-sub">
          <div className="main-sub-line">
            <div>
              <Location width={"30px"} height={"30px"} />
            </div>
            <div>Guadalajara – Envíos a todo México</div>
          </div>
          <div className="main-sub-line">
            <a href="/tel" target="_blank" className="main-anchor">
              <div>
                <Whatsapp width={"30px"} height={"30px"} />
              </div>
              <div>332 959 7262</div>
            </a>
          </div>
          <div className="main-sub-line click">
            <a href="/instagram" target="_blank" className="main-anchor">
              <div>
                <Instagram width={"30px"} height={"30px"} />
              </div>
              krono.mex
            </a>
          </div>
        </div>
      </center>
    </>
  );
};
